var RDSendReportModule = (function () {
    function RDSendReportModule() {
    }
    return RDSendReportModule;
}());
export { RDSendReportModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.module.ts.pre-build-optimizer.js